import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BbTableService, BbTableSelectOption } from '../../../services/bb-table.service';
import { OverlayService, DialogDefinition } from '../../../services/overlay.service';
import { SapiService } from '../../../services/sapi.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { AuthenticationService } from '../../../services/authentication.service';
import { CustomFieldsService } from '../../../services/custom-fields.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PublicationService } from '../../../services/publication.service';

@Component({
	selector: 'custom-field-list',
	templateUrl: './custom-field-list.component.html',
	styleUrls: ['./custom-field-list.component.scss'],
	providers: [BbTableService]
})

export class CustomFieldListComponent implements OnInit {

	filterConfig: BbFilterConfiguration;
	deleteRight = false;
	customfields: any;

	constructor(protected bbTableService: BbTableService,
		protected sapiService: SapiService,
		protected router: Router,
		protected overlayService: OverlayService,
		protected translate: TranslateService,
		protected publicationService: PublicationService,
		protected authenticationService: AuthenticationService,
		protected customfieldsService: CustomFieldsService) {


		this.authenticationService.hasPermission('delete').subscribe(hasRight => this.deleteRight = hasRight);
	}

	ngOnInit() {

		this.bbTableService
			.setConfigurable(false)
			.setSelect(BbTableSelectOption.none)
			.linkToUrl();

		this.publicationService.getData().subscribe(() => {
			this.customfields = this.customfieldsService.getCustomFields('mediaclip');
		});
	}

	reorder(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.customfields, event.previousIndex, event.currentIndex);
		this.save();
	}

	save() {
		this.overlayService.setLoading(true);
		this.sapiService.putUrl('/publication/customfields/mediaclip', this.customfields).subscribe(() => {
			this.overlayService.setLoading(false);
			this.overlayService.createToast(this.translate.instant('CUSTOM_FIELDS_SORT_ORDER_SAVED'), 'save');
		});
	}

	deleteSingle(row: any, dialogContents?: string) {
		if (!dialogContents) {
			dialogContents = this.translate.instant('DELETE_ENTITY_CONFIRM', { entity: this.translate.instant('CUSTOM_FIELD').toLowerCase() });
		}

		const dialog: DialogDefinition = {
			icon: 'trash',
			title: this.translate.instant('DELETE_CUSTOM_FIELD', { entity: row.label }),
			contents: dialogContents,
			onConfirm: () => {
				for (let i = 0; i < this.customfields.length; i++) {
					if (this.customfields[i] === row) {
						this.customfields.splice(i, 1);

						this.overlayService.setLoading(true);
						this.sapiService.putUrl('/publication/customfields/mediaclip', this.customfields).subscribe(() => {
							this.overlayService.setLoading(false);
							const msg = this.translate.instant('CUSTOM_FIELD_DELETED', { entity: this.translate.instant('CUSTOM_FIELD') });
							this.overlayService.createToast(msg, 'trash');
						});
					}
				}
			}
		};
		this.overlayService.createDialog(dialog);
	}

	redirectToDetails(row: any) {
		if (row && row.name) {
			this.router.navigate(['/publication/custom-field/mediaclip', row.name]);
		}
	}
}
